import { createBrowserHistory } from 'history';
import * as Sentry from '@sentry/react';

const history = createBrowserHistory();

export const feedback = Sentry.feedbackIntegration({
  showBranding: false,
  // Additional SDK configuration goes in here, for example:
  colorScheme: 'dark',
  useSentryUser: {
    email: 'email',
    name: 'fullName',
  },
  // Disable the injection of the default widget
  autoInject: false,

  // triggerLabel: 'Feedback',
  // formTitle: 'Send Feedback',
  // messagePlaceholder: 'What is your request? What\'s the bug? What did you expect?',
});

if (import.meta.env.PROD) {
  Sentry.init({
    dsn: 'https://f45f8c3c05ea40b548eccf0d32283121@o4508627304906752.ingest.us.sentry.io/4508765017079808',
    integrations: [
      feedback,
      Sentry.reactRouterV5BrowserTracingIntegration({ history }),
      Sentry.replayIntegration(),
    ],

    // Tracing
    tracesSampleRate: 0.1, //  Capture 10% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      /^https:\/\/app.ecosconnect.com/,
      /^https:\/\/api.ecosconnect.com/,
    ],
    // Session Replay
    replaysSessionSampleRate: 1.0, // You may want to set it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}
